"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Box = _interopRequireDefault(require("../Box"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _styles = require("./styles");

var _excluded = ["bgColor", "border", "borderColor", "children", "leftIcon", "info", "paddingType", "paddingSize", "radius", "title", "theme"];

var Info = function Info(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 10.8387C3.31452 10.8387 1.16129 8.68548 1.16129 6C1.16129 3.33871 3.31452 1.16129 6 1.16129C8.66129 1.16129 10.8387 3.33871 10.8387 6C10.8387 8.68548 8.66129 10.8387 6 10.8387ZM6 2.66129C5.41935 2.66129 4.98387 3.12097 4.98387 3.67742C4.98387 4.25806 5.41935 4.69355 6 4.69355C6.55645 4.69355 7.01613 4.25806 7.01613 3.67742C7.01613 3.12097 6.55645 2.66129 6 2.66129ZM7.35484 8.80645V8.22581C7.35484 8.08065 7.20968 7.93548 7.06452 7.93548H6.77419V5.51613C6.77419 5.37097 6.62903 5.22581 6.48387 5.22581H4.93548C4.76613 5.22581 4.64516 5.37097 4.64516 5.51613V6.09677C4.64516 6.26613 4.76613 6.3871 4.93548 6.3871H5.22581V7.93548H4.93548C4.76613 7.93548 4.64516 8.08065 4.64516 8.22581V8.80645C4.64516 8.97581 4.76613 9.09677 4.93548 9.09677H7.06452C7.20968 9.09677 7.35484 8.97581 7.35484 8.80645Z"
  }));
};

Info.defaultProps = {
  viewBox: "0 0 12 12",
  fill: "#637792",
  xmlns: "http://www.w3.org/2000/svg"
};

var Card = function Card(_ref) {
  var bgColor = _ref.bgColor,
      border = _ref.border,
      borderColor = _ref.borderColor,
      children = _ref.children,
      leftIcon = _ref.leftIcon,
      info = _ref.info,
      paddingType = _ref.paddingType,
      paddingSize = _ref.paddingSize,
      radius = _ref.radius,
      title = _ref.title,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Box.default, Object.assign({
    border: border,
    borderColor: borderColor,
    paddingType: "square",
    paddingSize: "none",
    background: theme.colors[bgColor].color + theme.colors[bgColor].scale || theme.colors.ghost,
    radius: radius
  }, rest), /*#__PURE__*/_react.default.createElement(_styles.CardHeader, {
    paddingType: paddingType,
    paddingSize: paddingSize
  }, /*#__PURE__*/_react.default.createElement(_styles.Header, null, leftIcon && /*#__PURE__*/_react.default.createElement(_styles.Icon, null, leftIcon), title, info && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    label: info,
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_styles.Icon, {
    className: "right"
  }, /*#__PURE__*/_react.default.createElement(Info, null))))), /*#__PURE__*/_react.default.createElement(_styles.CardBody, null, children));
};

Card.defaultProps = {
  bgColor: 'ghost',
  border: true,
  paddingType: 'square',
  paddingSize: 'sm',
  radius: 'none'
};

var _default = (0, _styledComponents.withTheme)(Card);

exports.default = _default;